import { DocumentDescription } from 'documents-ui/components/description/DocumentDescription';
import { jsx as _jsx } from "react/jsx-runtime";
const SummaryHeaderDescription = ({
  deckId
}) => {
  return /*#__PURE__*/_jsx(DocumentDescription, {
    deckId: deckId
  });
};
export default SummaryHeaderDescription;